// index.js
import { createRouter, createWebHistory } from 'vue-router'

import LoginView from '../components/LoginView'
import SignupView from '../components/SignupView'
import OrdersList from '../components/OrdersList'
import OrderDetail from '../components/OrderDetail'
import CreateOrder from '../components/CreateOrder'
import ViewTemplates from '../components/ViewTemplates'
import TemplateDetail from '@/components/TemplateDetail.vue'
import CreateTemplate from '@/components/CreateTemplate.vue'
import PrintOrder from '@/components/PrintOrder.vue'
import Reports from '@/components/Reports.vue'
import IssuesList from '../components/IssuesList.vue'
import CustomersList from '../components/CustomersList.vue'
import CustomerDetail from '../components/CustomerDetail.vue'
import CreateCustomer from '../components/CreateCustomer.vue'
import Dashboard from '../components/Dashboard.vue'
import ActivityLogView from '../components/ActivityLog.vue'
import DeviceModelsList from '../components/DeviceModelsList.vue'
import CreateDeviceModel from '../components/CreateDeviceModel.vue'
import CSVImport from '../components/CSVImport.vue'
import BatchCreate from '../components/BatchCreate.vue'
import BatchPrintOrders from '../components/BatchPrintOrders.vue'
import SalesQueue from '../components/SalesQueue.vue'

const routes = [
  { path: '/', redirect: '/dashboard' },

  { path: '/dashboard', name: 'Dashboard', component: Dashboard, meta: { title: 'Dashboard' } },
  { path: '/login', name: 'Login', component: LoginView, meta: { title: 'Login' } },
  { path: '/signup', name: 'Signup', component: SignupView, meta: { title: 'Sign Up' } },

  { path: '/templates', name: 'ViewTemplates', component: ViewTemplates, meta: { title: 'Templates' } },
  { path: '/templates/create', name: 'CreateTemplate', component: CreateTemplate, meta: { title: 'New Template' } },
  { path: '/templates/:id', name: 'TemplateDetail', component: TemplateDetail, meta: { title: 'Template' } },
  { path: '/templates/:id/edit', name: 'EditTemplate', component: CreateTemplate, meta: { title: 'Edit Template' } },

  { path: '/orders', name: 'OrdersList', component: OrdersList, meta: { title: 'Devices' } },
  { path: '/orders/batch', name: 'BatchCreate', component: BatchCreate, meta: { title: 'Batch Create' } },
  { path: '/orders/new', name: 'CreateOrder', component: CreateOrder, meta: { title: 'New Device' } },
  { path: '/orders/:id', name: 'OrderDetail', component: OrderDetail, meta: { title: 'Device' } },
  { path: '/orders/print-batch', name: 'BatchPrintOrders', component: BatchPrintOrders, meta: { hideLayout: true, title: 'Print Labels' } },
  { path: '/orders/:id/print', name: 'PrintOrder', component: PrintOrder, meta: { hideLayout: true, title: 'Print Label' } },

  { path: '/reports', name: 'Reports', component: Reports, meta: { title: 'Reports' } },

  { path: '/issues', name: 'IssuesList', component: IssuesList, meta: { title: 'All Issues' } },

  { path: '/customers', name: 'CustomersList', component: CustomersList, meta: { title: 'Customers' } },
  { path: '/customers/new', name: 'CreateCustomer', component: CreateCustomer, meta: { title: 'New Customer' } },
  { path: '/customers/:id', name: 'CustomerDetail', component: CustomerDetail, meta: { title: 'Customer' } },

  { path: '/activity-log', name: 'ActivityLog', component: ActivityLogView, meta: { title: 'Activity Log' } },

  { path: '/device-models', name: 'DeviceModelsList', component: DeviceModelsList, meta: { title: 'Device Models' } },
  { path: '/device-models/new', name: 'CreateDeviceModel', component: CreateDeviceModel, meta: { title: 'New Device Model' } },
  { path: '/device-models/:id/edit', name: 'EditDeviceModel', component: CreateDeviceModel, meta: { title: 'Edit Device Model' } },

  { path: '/import', name: 'CSVImport', component: CSVImport, meta: { title: 'Import CSV' } },

  { path: '/sales-queue', name: 'SalesQueue', component: SalesQueue, meta: { title: 'Sales Queue' } },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/signup']
  const authRequired = !publicPages.includes(to.path)
  const token = localStorage.getItem('accessToken')

  if (authRequired && !token) {
    return next('/login')
  }

  next()
})

router.afterEach((to) => {
  const base = 'Second Wind Refurbish'
  document.title = to.meta.title ? `${to.meta.title} | ${base}` : base
})

export default router
